import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const GET_LOW_STOCK_SUPPLIES_REQUEST = 'GET_LOW_STOCK_SUPPLIES_REQUEST';
export const GET_LOW_STOCK_SUPPLIES_SUCCESS = 'GET_LOW_STOCK_SUPPLIES_SUCCESS';
export const GET_LOW_STOCK_SUPPLIES_ERROR = 'GET_LOW_STOCK_SUPPLIES_ERROR';


export const getLowStockSupplies = () => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: GET_LOW_STOCK_SUPPLIES_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/supply/low-stock`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: GET_LOW_STOCK_SUPPLIES_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: GET_LOW_STOCK_SUPPLIES_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
